/* eslint-disable @typescript-eslint/no-explicit-any */
const useLogError = () => {

  const logError = (error: any): void => {
    try {
      console.log(error);
    } catch (e: any) {
      console.log(e);        
    }
  };

  const extractErrorMessage = (error: any): string => {
    try {
      if (error?.response?.data) {
        const responseData = error.response.data;
        if (typeof responseData === 'object' && responseData.message) {
          return responseData.message;
        }
        if (typeof responseData === 'string') {
          return responseData;
        }
      }
      if (error?.message) {
        return error.message;
      }
      return 'An unexpected error occurred.';
    } catch (e: any) {
      console.log('Error extracting error message:', e);
      return 'An unexpected error occurred.';
    }
  };
  return { logError, extractErrorMessage };
};

export default useLogError;